import { useEffect, useState } from 'react';
import { featureConstant } from '@/constants/configuration/feature';
import { useFeature } from '@/hooks/use-feature/index';
import API_SUBMITTALS from '@/services/api/submittalsDataElements.js';

const SESSION_KEY = 'submittalsDataElements';

const useSubmittalsDataElements = () => {
	const isSubmittalsEnabled = useFeature(featureConstant.SUBMITTALS);
	const [dataElements, setDataElements] = useState([]);

	useEffect(() => {
		if (!isSubmittalsEnabled) return;
		try {
			const cached = sessionStorage.getItem(SESSION_KEY);
			if (cached) {
				setDataElements(JSON.parse(cached));
				return;
			}
		} catch {
			sessionStorage.removeItem(SESSION_KEY);
		}
		API_SUBMITTALS.getSubmittalsDataElements().then(([error, data]) => {
			if (error) return;
			const items = data || [];
			sessionStorage.setItem(SESSION_KEY, JSON.stringify(items));
			setDataElements(items);
		}).catch(() => {});
	}, [isSubmittalsEnabled]);

	return { dataElements, isSubmittalsEnabled };
};

export default useSubmittalsDataElements;
